import { useRecoilState } from "recoil";
import instance from "helpers/instance";
import { authAtom } from "state/recoil-root";

const useReportPermissionActions = () => {
  const [auth] = useRecoilState(authAtom);
  const headers = {
    Authorization: `Bearer ${auth?.access_token}`,
  };

  return {
    getReports,
    getReportById,
    getPermissionsByReport,
    bulkUpsertPermissions,
    createPermission,
    updatePermission,
    searchUsers,
  };

  function getReports(filters = {}, page = 0, pageSize = 10) {
    const offset = page * pageSize;
    return instance({
      url: "report-service/v1/reports",
      method: "GET",
      params: {
        name: filters.name || null,
        sort_field: null,
        sort_type: null,
        offset,
        limit: pageSize,
      },
      headers,
    });
  }

  function getReportById(reportId) {
    return instance({
      url: `report-service/v1/reports/${reportId}`,
      method: "GET",
      headers,
    });
  }

  function getPermissionsByReport(reportId, page = 0, pageSize = 10, userId = null) {
    const offset = page * pageSize;
    return instance({
      url: "report-service/v1/user-report-permissions",
      method: "GET",
      params: {
        report_id: reportId || null,
        user_id: userId || null,
        offset,
        limit: pageSize,
      },
      headers,
    });
  }

  function bulkUpsertPermissions(items) {
    return instance({
      url: "report-service/v1/user-report-permissions/bulk",
      method: "POST",
      data: { items },
      headers,
    });
  }

  function createPermission(data) {
    return instance({
      url: "report-service/v1/user-report-permissions",
      method: "POST",
      data,
      headers,
    });
  }

  function updatePermission(id, data) {
    return instance({
      url: `report-service/v1/user-report-permissions/${id}`,
      method: "PUT",
      data,
      headers,
    });
  }

  function searchUsers(query = "", offset = 0, limit = 50) {
    return instance({
      url: "usermanagement/v1/users",
      method: "GET",
      params: {
        offset,
        limit,
        email: query || null,
        role_ids: "",
        status: 1,
        sort_type: "",
        sort_field: "",
      },
      headers,
    });
  }
};

export { useReportPermissionActions };
